import React, { useState } from 'react';
import { motion } from 'framer-motion';

const FAQ: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What services does Wevatar provide?',
      answer:
        'We provide complete web development solutions including business websites, web applications, e-commerce platforms, backend systems, APIs, UI/UX development, and website maintenance services.'
    },
    {
      question: 'Do you build custom websites?',
      answer:
        'Yes. Every project is custom-designed and developed based on business requirements, branding, functionality, and scalability needs.'
    },
    {
      question: 'Which technologies do you work with?',
      answer:
        'We work with technologies including Node.js, Express.js, PHP, HTML, CSS, JavaScript, Bootstrap, Tailwind CSS, MySQL, MongoDB, APIs, and modern frontend/backend tools.'
    },
    {
      question: 'Are your websites mobile responsive?',
      answer:
        'Yes. All websites and applications are fully responsive and optimized for desktop, tablet, and mobile devices.'
    },
    {
      question: 'Do you provide website maintenance and support?',
      answer:
        'Yes. We offer ongoing maintenance, bug fixing, updates, security improvements, and technical support services.'
    },
    {
      question: 'Can you redesign existing websites?',
      answer:
        'Yes. We can modernize outdated websites with improved UI/UX, performance optimization, responsiveness, and SEO-friendly structure.'
    },
    {
      question: 'Do you provide SEO-friendly development?',
      answer:
        'Yes. We follow SEO-friendly development practices including optimized structure, clean code, performance optimization, and responsive design.'
    }
  ];

  return (
    <motion.section id="faq" className="faq" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
      <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
        Frequently Asked Questions
      </motion.h2>
      <p className="section-subtitle">Got Questions? We’ve Got Clear Answers.</p>
      <div className="faq-grid">
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
            <button className="faq-question" onClick={() => setActiveIndex(activeIndex === index ? null : index)}>
              <span>{faq.question}</span>
              <span className="faq-icon">{activeIndex === index ? '-' : '+'}</span>
            </button>
            <motion.div
              className="faq-answer"
              initial={{ height: 0, opacity: 0 }}
              animate={activeIndex === index ? { height: 'auto', opacity: 1 } : { height: 0, opacity: 0 }}
              transition={{ duration: 0.42, ease: [0.25, 0.8, 0.25, 1] }}
            >
              <p>{faq.answer}</p>
            </motion.div>
          </div>
        ))}
      </div>
    </motion.section>
  );
};

export default FAQ;
